import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`
let baseUrl2 = `${httpUrl.host}/gy-apartment`

let api = {
  // 获取首页数据
  getHomeData: `${baseUrl}/homePage/home`,

  // 获取首页楼栋数据
  getBuildingList: `${baseUrl}/homePage/getBuildingList`,

  // 获取园区信息
  getYqInfo: `${baseUrl}/yqInfo/getYqInfo`,

  // 获取平台端服务开通信息
  getYqServerConfig: `${baseUrl2}/config/getList`,

  // 修改平台端服务开通信息
  updateyqServerConfig: `${baseUrl2}/config/update`,

  // 获取小程序应用模块
  getYqFunctionCode: `${baseUrl2}/config/getYqFunctionCode`,

  // 更新小程序启用的模块
  updateyqFunctionCode: `${baseUrl2}/config/updateyqFunctionCode`,

  // 获取人脸配置参数
  getFaceConfig: `${baseUrl2}/config/getFaceConfig`,

  // 修改人脸配置参数
  updateFaceConfig: `${baseUrl2}/config/updateFaceConfig`,

  // 获取人脸收费信息
  getFacePayConfig: `${baseUrl2}/config/getByCode`,

  // 修改人脸收费信息
  updateFacePayConfig: `${baseUrl2}/config/updateFacePayConfig`,

  // 微信账户
  getWxDepositAccountPage: `${baseUrl}/wxDepositAccount/getPage`,

  // 添加微信账户
  addWxDepositAccountPage: `${baseUrl}/wxDepositAccount/add`,

  // 修改微信账户
  modifyWxDepositAccountPage: `${baseUrl}/wxDepositAccount/update`,

  updateByCode: `${baseUrl2}/config/updateByCode`,

  // 大华云睿
  getVideoStore: `${baseUrl2}/config/getVideoStore`,

  setVideoStore: `${baseUrl2}/config/setVideoStore`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/Config.js